import { useEffect } from "react";
import { buildClasses } from "../utils/buildClasses";
import { Footer } from "./Footer";
import { Header } from "./Header";
import { PageMeta } from "./PageMeta";
import { SignUpAction } from "./SignUpAction";

const PRICE_PER_MONTH = "$3";
export function PricingPage() {
  // Note the block body: an expression-bodied effect would return whatever
  // window.scrollTo() evaluates to, and React treats an effect's return value as
  // its cleanup function. That threw "destroy is not a function" on unmount.
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div
      className={buildClasses("website-page", "w-full", "bg-base", "isolate")}
    >
      <PageMeta
        title="Pricing | Bread"
        description="$3 per month. Billed annually. Cancel any time for a refund of all unused months."
        path="/pricing"
      />
      <Header />

      <section
        className={buildClasses(
          "mx-auto",
          "w-[92%]",
          "max-w-3xl",
          // Pulled up under the sticky header (h-16) so the section spans the
          // whole window, which centers the content against the full window
          // rather than just the area below the header. It also keeps the footer
          // out of sight until the visitor scrolls. The top padding clears the
          // header on windows too short for centering to do it.
          "-mt-16",
          "flex",
          "min-h-screen",
          "flex-col",
          "justify-center",
          // Equal top and bottom padding: uneven padding shifts the centered
          // content off the window's middle.
          "py-32",
        )}
      >
        <div
          className={buildClasses(
            "rounded-3xl",
            "bg-purple-100",
            "px-6",
            "py-16",
            "md:px-12",
            "md:py-20",
            "text-center",
          )}
        >
          <h1
            className={buildClasses(
              "text-3xl",
              "md:text-4xl",
              "font-normal",
              "tracking-tight",
              "text-balance",
              "text-on-surface-800",
            )}
          >
            {PRICE_PER_MONTH} per month
          </h1>
          <p
            className={buildClasses(
              "mx-auto",
              "mt-6",
              "max-w-sm",
              "text-balance",
              "text-base",
              "leading-relaxed",
              "text-on-surface-600",
            )}
          >
            Billed annually. Cancel any time for a refund of all unused months.
          </p>

          <div className={buildClasses("mt-10", "flex", "justify-center")}>
            <SignUpAction label="Get started" arrow />
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
